__turbopack_context__.v({
  "Input": "CommentInput-module-scss-module__tQoSpW__Input",
  "Label": "CommentInput-module-scss-module__tQoSpW__Label",
  "accent": "CommentInput-module-scss-module__tQoSpW__accent",
  "content": "CommentInput-module-scss-module__tQoSpW__content",
  "hidden": "CommentInput-module-scss-module__tQoSpW__hidden",
  "lbl": "CommentInput-module-scss-module__tQoSpW__lbl",
  "primary": "CommentInput-module-scss-module__tQoSpW__primary",
  "replying": "CommentInput-module-scss-module__tQoSpW__replying",
  "root": "CommentInput-module-scss-module__tQoSpW__root",
  "submitBtn": "CommentInput-module-scss-module__tQoSpW__submitBtn",
});
